import { Dialogs } from '@leverege/ui-elements';
import { Config } from '@leverege/plugin';
import Molten from '@leverege/molten';
import RemoveFromConsumerNetworkDialog from './RemoveFromConsumerNetworkDialog';
const objectType = 'vehicle';
export default {
  id: 'recovr.removeFromConsumerNetwork',
  name: 'Remove From Consumer Network',
  // layout : { sort : 'vehicle.removeFromConsumerNetwork', sectionName : 'Vehicle Actions' },
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    path: ['vehicle', 'company.locations.vehicles'],
    objectType
  }],
  handles: cxt => {
    // TODO: Don't include this plugin at all if we aren't in device management ui?
    const uiName = Molten.getConfig('uiName');
    if (uiName !== 'deviceManagement') {
      return false;
    }
    const targets = cxt?.target || [];
    if (targets.length !== 1) {
      return false;
    }
    const vehiclesInConsumerNetworkAndLocation = targets.filter(isVehicleInConsumerLocationAndNetwork);
    return vehiclesInConsumerNetworkAndLocation.length > 0;
  },
  appearance: cxt => {
    return {
      name: 'Release VIN for Dealers',
      icon: 'https://storage.googleapis.com/molten-ui-assets/remove-action.png'
    };
  },
  perform: data => {
    const {
      context
    } = data;
    const targets = context?.target || [];
    Dialogs.show({
      component: RemoveFromConsumerNetworkDialog,
      props: {
        vehicles: targets
      }
    });
  }
};

/**
 * Filter vehicles that are in consumer location and network
 */
function isVehicleInConsumerLocationAndNetwork(target) {
  const consumerNetworkId = Config.get('VehicleNetwork.consumer', 'id');
  const consumerLocationId = Config.get('ConsumerLocation', 'id');
  if (target?.type !== objectType) {
    return false;
  }
  const vehicleNetworkId = target?.data?.networkId;
  const isInConsumerNetwork = vehicleNetworkId === consumerNetworkId;
  const vehicleLocationId = target?.data?.data?.location?.id;
  const isInConsumerLocation = vehicleLocationId === consumerLocationId;
  return isInConsumerNetwork && isInConsumerLocation;
}